import { DashboardGraphScope, DashboardViewMode } from "./types";

export const DASHBOARD_LOOKBACK_MONTHS = 12;

export const DEFAULT_GRAPH_SCOPE: DashboardGraphScope = "month";

export const DEFAULT_VIEW_MODE: DashboardViewMode = "charts";

export const GRAPH_SCOPE_OPTIONS = [
  { labelKey: "week", scope: "week" },
  { labelKey: "month", scope: "month" },
  { labelKey: "year", scope: "year" },
] as const satisfies readonly {
  labelKey: DashboardGraphScope;
  scope: DashboardGraphScope;
}[];

export const GRAPH_SCOPE_ROLLING_WINDOW_DAYS: Record<
  DashboardGraphScope,
  number
> = {
  month: 30,
  week: 7,
  year: 365,
};

export const GRAPH_SCOPE_BUCKET_COUNT: Record<DashboardGraphScope, number> = {
  month: 12,
  week: 12,
  year: 3,
};

export const VIEW_MODE_OPTIONS = [
  { labelKey: "charts", viewMode: "charts" },
  { labelKey: "table", viewMode: "table" },
] as const satisfies readonly {
  labelKey: DashboardViewMode;
  viewMode: DashboardViewMode;
}[];
